/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { APIErrorSchema } from "./APIErrorSchema.ts"
import { z } from "zod/v4"

/**
 * @description Successfully invalidated the access token.
 */
export const signout200Schema = z.object({
  message: z.string(),
})

/**
 * @description The \"Authorization\" header does not contain a valid Bearer access token.
 */
export const signout401Schema = APIErrorSchema

export const signoutMutationResponseSchema = signout200Schema
